"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkableBaseStyles = void 0;

var _styleHelpers = require("../styleHelpers");

var checkableBaseStyles = {
  innerPadding: {
    medium: (0, _styleHelpers.getSpacing)(3),
    small: (0, _styleHelpers.getSpacing)(2)
  },
  borderWidth: 1,
  borderColor: (0, _styleHelpers.getColor)('borders'),
  backgroundColor: (0, _styleHelpers.getColor)('common', 'white'),
  handleSize: {
    medium: (0, _styleHelpers.getSpacing)(5),
    small: (0, _styleHelpers.getSpacing)(4)
  },
  focus: {
    outlineSize: '3px',
    outlineColor: (0, _styleHelpers.getColor)('brand', 'lightest')
  },
  boxTransition: [['box-shadow', '0.3s', 'ease-in-out']],
  handleTransition: [['transform', '0.15s', 'cubic-bezier(0.34, 1.56, 0.64, 1)']],
  typographyVariant: {
    medium: 'subtitle',
    small: 'paragraph'
  }
};
exports.checkableBaseStyles = checkableBaseStyles;